export const visit = (vm, at) => {
at({ "cs": { "conversationsVisitorUIAvailability": { "sameDay": "Zp\xE1tky budeme dnes v {{time}}.", "nextDay": "Zp\xE1tky budeme z\xEDtra v {{time}}.", "nextWeek": "Zp\xE1tky budeme: {{dayOfWeek}} {{time}}" } } });
};